import { PrefetchMediaUrl } from './prefetch-media-url';

export class MediaSectionAssetUrl extends PrefetchMediaUrl {}
